import React from 'react';
import { Box } from '@mui/material';
import {
  Assignment as TaskIcon,
  People as PeopleIcon,
} from '@mui/icons-material';
import { DefaultUserStats } from '../../../types/statistics';
import { StatCard } from '../StatCard';
import { DashboardTabs } from '../DashboardTabs';

interface DefaultUserViewProps {
  data: DefaultUserStats;
}

export const DefaultUserView: React.FC<DefaultUserViewProps> = ({ data }) => {
  return (
    <DashboardTabs overviewType="user">
      <Box sx={{ display: 'flex', flexWrap: 'wrap', mx: -1.5 }}>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Tasks"
            value={data.my_tasks}
            icon={<TaskIcon />}
            color="#2563eb"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="Assigned Tasks"
            value={data.my_assigned_tasks}
            icon={<TaskIcon />}
            color="#ea580c"
          />
        </Box>
        <Box sx={{ width: { xs: '100%', sm: '50%', md: '25%' }, p: 1.5 }}>
          <StatCard
            title="My Contacts"
            value={data.my_contacts}
            icon={<PeopleIcon />}
            color="#9333ea"
          />
        </Box>
      </Box>
    </DashboardTabs>
  );
};
